import apiClient from './apiClient';

export const customerBookingService = {
    // Get customer's bookings
    getMyBookings: async (params = {}) => {
        try {
            const response = await apiClient.get('/customer/my-bookings', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new booking
    createBooking: async (bookingData) => {
        try {
            const response = await apiClient.post('/customer/my-bookings', bookingData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get single booking details
    getBooking: async (bookingId) => {
        try {
            const response = await apiClient.get(`/customer/my-bookings/${bookingId}`);
            console.log('Raw API response:', response);
            return response.data;
        } catch (error) {
            console.error('API error:', error);
            throw error.response?.data || error.message;
        }
    },

    // Calculate shipping rate
    calculateRate: async (rateData) => {
        try {
            const response = await apiClient.post('/customer/calculate-rate', rateData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get available cities
    getCities: async () => {
        try {
            const response = await apiClient.get('/customer/booking-cities');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get available products
    getProducts: async () => {
        try {
            const response = await apiClient.get('/customer/booking-products');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Recalculate rate for existing booking
    recalculateRate: async (bookingId) => {
        try {
            const response = await apiClient.get(`/customer/my-bookings/${bookingId}/recalculate-rate`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};
